import { useState } from "react";
import BreadCrumb from "../Controls/BreadCrumb";
import "../../style/scss/Admin.scss";
import EmployerSearch from "../Controls/EmployerSearch";
import SkillSearch from "../Controls/SkillSearch";
import CustomButton from "../Controls/CustomButton";
import { useNavigate, Link } from "react-router-dom";
import EmployerEditModal from "../Modals/EmployerEditModal";

export default function AdminDashboardView() {
  const navigate = useNavigate();
  const [employerEditId, setEmployerEditId] = useState(null);

  const editEmployer = (value) => {
    const id = value?.ID ?? value?.id;
    if (!id) return;
    setEmployerEditId(id);
  };

  const editSkill = (value) => {
    const id = value?.ID ?? value?.id;
    if (!id) return;
    navigate("/adminSkillEdit/" + id);
  };

  return (
    <div>
      <BreadCrumb props={["Admin"]} />
      <div className="adminTabbody tabBody">
        <h2>Site Administration Tasks</h2>
        <div className="leftPanel">
          <ul className="admin">
            <li>
              <Link to="/adminPackageItemTypes">
                <CustomButton fullWidth={true} variant="contained" color="primary">
                  Manage Package Item Types
                </CustomButton>
              </Link>
            </li>
            <li>
              <Link to="/adminAgreements">
                <CustomButton fullWidth={true} variant="contained" color="primary">
                  Manage Agreements
                </CustomButton>
              </Link>
            </li>
          </ul>
        </div>

        <div className="rightPanel">
          <ul className="admin">
            <li>
              <EmployerSearch label="Edit Employer/Company" onSelect={editEmployer} />
            </li>
            <li>
              <SkillSearch label="Edit Skill" onSelect={editSkill} />
            </li>
          </ul>
        </div>
      </div>
      {employerEditId != null ? (
        <EmployerEditModal
          employerId={employerEditId}
          onClose={() => setEmployerEditId(null)}
        />
      ) : null}
    </div>
  );
}
